/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useTranslation } from 'react-i18next';
import { TableCell } from '@material-ui/core';
import React from 'react';
import CustomCheckbox from 'components/CustomCheckbox';
import useStyles from '../FOTableHeadStyle';

const FOHeadCheckCell = ({ isAllSelected, handleSelectAll, data }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const ariaLabel = isAllSelected() ? t(data?.activeAriaLabel) : t(data?.ariaLabel);
  return (
    <TableCell className={classes.noRightBorder}>
      <CustomCheckbox
        checked={isAllSelected()}
        onChange={handleSelectAll}
        inputProps={{
          'aria-label': ariaLabel,
          'data-testid': 'checkboxSelect',
        }}
      />
    </TableCell>
  );
};

export default FOHeadCheckCell;
